import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setEmailNotificationModalOpen,
    setEmailNotificationPage,
    get_email_notification_list,
    create_email_notification,
    update_email_notification,
    setAction,
    setId,
    setStatus,
    setSearchQuery,
    activate_deactivate_email_notification,
    get_email_notification_details,
    setSelectedData
} from "../../../store/email_notification/emailNotificationSlice";
import { get_company_list } from "../../../store/company/companySlice";
import { get_process_list } from "../../../store/process/processSlice";
import { get_stage_list } from "../../../store/stage/stageSlice";

const mapStateToProps = (state) => {
    const {
        is_email_notification_modal_open,
        email_notification_list,
        common_loading,
        total_email_notification_count,
        active_email_notification,
        page,
        c_action,
        email_notification_id,
        selected_status,
        search_query,
        selected_data
    } = state.email_notification;
    const { company_list } = state.company;
    const { process_list } = state.process;
    const { stage_list } = state.stage;
    return {
        is_email_notification_modal_open: is_email_notification_modal_open,
        email_notification_list: email_notification_list,
        total_email_notification_count: total_email_notification_count,
        common_loading: common_loading,
        active_email_notification: active_email_notification,
        page: page,
        c_action: c_action,
        email_notification_id: email_notification_id,
        selected_status: selected_status,
        search_query: search_query,
        selected_data: selected_data,
        company_list: company_list,
        process_list: process_list,
        stage_list: stage_list
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        setEmailNotificationModalOpen,
        setEmailNotificationPage,
        get_email_notification_list,
        create_email_notification,
        update_email_notification,
        setAction,
        setId,
        setStatus,
        setSearchQuery,
        activate_deactivate_email_notification,
        get_email_notification_details,
        setSelectedData,
        get_company_list,
        get_process_list,
        get_stage_list
    }, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
